import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgSendIcon = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 16,
	height: 16,
	viewBox: "0 0 16 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M4.9266 12.843C4.75787 12.914 4.57129 12.7901 4.57129 12.6071V4.95705C4.57129 4.77398 4.75787 4.6501 4.9266 4.72114L14.011 8.54614C14.2198 8.63408 14.2198 8.93003 14.011 9.01797L4.9266 12.843ZM5.62392 11.4136L11.7473 9.02047C11.9643 8.93564 11.9643 8.62848 11.7473 8.54365L5.62392 6.15048V7.79273C5.62392 7.91019 5.70386 8.01257 5.81781 8.04106L7.78849 8.53373C8.04701 8.59836 8.04701 8.96576 7.78849 9.03039L5.81781 9.52306C5.70386 9.55155 5.62392 9.65393 5.62392 9.77139V11.4136Z",
		fill: "#1F3171"
	})
});
export default SvgSendIcon;
